export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.12-1646.50",
  commitId: "d3eb094518ee3a05aa90081c77f000ccd78af467",
  commitTime: "2026-08-12T16:46:50.000Z",
});
